import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { fetchUserThunk, fetchOrderByIdThunk, fetchProductByIdThunk } from '../thunks/thunks';
import Nav from './Nav';

const UserProfile = () => {
  const dispatch = useDispatch();
  const [orderProducts, setOrderProducts] = useState({});
  
  useEffect(() => {
    dispatch(fetchUserThunk());
  }, [dispatch]);

  // Access the Redux state
  const user = useSelector((state) => state.auth.personalinfo);
  const orders = user?.orderIds || [];

  // Function to fetch products by orderId
  const fetchProductsForOrder = async (orderId) => {
    try {
      // First, fetch the order to get the productIds
      const orderResponse = await dispatch(fetchOrderByIdThunk(orderId));
      console.log("orderResponse",orderResponse);
      const order = orderResponse.payload; // Assuming the payload contains the order data

      const productIds = order.productIds; // Array of product IDs from the order
      if (!productIds || productIds.length === 0) return;

      // Now, fetch the product details using each productId
      const productsData = await Promise.all(
        productIds.map(async (productId) => {
          const productResponse = await dispatch(fetchProductByIdThunk(productId));
          return productResponse.payload; // Assuming payload contains the product data
        })
      );

      // Store the fetched products for this order in the state
      setOrderProducts((prev) => ({
        ...prev,
        [orderId]: productsData,
      }));
    } catch (error) {
      toast.error("Failed to fetch products for order");
    }
  };

  useEffect(() => {
    // Fetch product details for each order
    orders.forEach((order) => {
      fetchProductsForOrder(order._id);
    });
  }, [orders]);

  return (
    <div className="min-h-screen bg-custom-pink items-center justify-center">
      <Nav />
      <div className="bg-white w-full max-w-4xl p-8 rounded-lg shadow-2xl ml-auto mr-auto mt-8">
        
        {user ? (
          <div className="space-y-8">
            {/* Profile Section */}
            <div className="bg-white p-6 rounded-lg shadow-xl">
              <h1 className="text-4xl font-semibold text-left text-pink-600 mb-4">Welcome {user.name} !</h1>
              <div className="space-y-4 text-lg text-gray-700">
                <p><strong className="font-bold text-pink-600">Email:</strong> {user.email}</p>
                <p><strong className="font-bold text-pink-600">Phone:</strong> {user.phone}</p>
                {user.permission === "admin" && (
                  <p><strong className="font-bold text-pink-600">Permission:</strong> {user.permission}</p>
                )}
              </div>
            </div>

            {/* Orders Section */}
            <div className="bg-white p-6 rounded-lg shadow-xl">
              <h2 className="text-3xl font-semibold text-left text-pink-600 mb-4">Orders</h2>
              {orders && orders.length > 0 ? (
                <table className="min-w-full table-auto">
                  <thead className="bg-pink-200">
                    <tr>
                      <th className="px-6 py-3 text-left text-pink-600">Products</th>
                      <th className="px-6 py-3 text-left text-pink-600">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map((order) => (
                      <tr key={order._id} className="border-b hover:bg-pink-100">
                        <td className="px-6 py-4 text-gray-700">
                          {/* Display products for each order */}
                          {orderProducts[order._id] ? (
                            orderProducts[order._id].map((product, index) => (
                              <div key={index} className="text-gray-700">
                                <p>{product.name}</p>
                              </div>
                            ))
                          ) : (
                            <p>Loading products...</p>
                          )}
                        </td>
                        <td className="px-6 py-4 text-gray-700">{order.status}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="text-gray-700">No orders found</p>
              )}
            </div>
          </div>
        ) : (
          <p className="text-center text-gray-700">No user data available</p>
        )}
      </div>
    </div>
  );
};

export default UserProfile;
